import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class SecondaryTradingAdditionSettingsComponentCtrl implements ng.IController {
    tradingConditions: TradingConditionsSecondarySettingsDto[];
    authenticatedUser: LoginResult;
    file: File;
    documentTitle: string;
    fileName: string;
    documentUploadForm: ng.IFormController;
    uploading: boolean;
    private idOfTradingConditionBeingDeleted: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit() {}

    submit(isValid: boolean): boolean {
        if (!isValid) {
            return false;
        }

        this.uploading = true;

        const formData: FormData = new FormData();
        formData.append('file', this.file);
        formData.append('title', this.documentTitle);

        this.TransmissionSystemOperator.uploadAdditionalTradingConditions(
            { id: this.authenticatedUser.referenceId },
            formData,
            (res: TradingConditionsSecondarySettingsDto) => {
                this.tradingConditions.push(res);
                this.file = null;
                this.fileName = null;
                this.documentTitle = null;
                this.documentUploadForm.$setPristine();

                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        ).$promise.finally(() => (this.uploading = false));

        return true;
    }

    delete(tradingConditionId: number): void {
        this.idOfTradingConditionBeingDeleted = tradingConditionId;

        this.TransmissionSystemOperator.deleteAdditionalTradingConditions(
            { tradingConditionId },
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
                this.tradingConditions.splice(
                    this.tradingConditions.findIndex(
                        (tC) => tC.tradeConditionsId === tradingConditionId
                    ),
                    1
                );
            },
            this.errorHandler
        ).$promise.finally(
            () => (this.idOfTradingConditionBeingDeleted = null)
        );
    }
}

angular
    .module('app')
    .component('pkpSecondaryTradingAdditionalConditionsSettings', {
        controller: SecondaryTradingAdditionSettingsComponentCtrl,
        template:
            require('app/operator-settings-secondary-market/secondary-trading-additional-conditions-settings.component.html'),
        bindings: {
            tradingConditions: '=',
            authenticatedUser: '=',
            enableAdditionalConditions: '='
        }
    });
